import React from "react";

import asIcon from "./asIcon";

export default asIcon(
  ({ color, strokeWidth = 1 }) =>
    <path stroke={color} strokeWidth={strokeWidth} fill={color} d="M39.1 61.4l4.1 4.2a2.2 2.2 0 0 0 3.1 0l25.9-26.2a2.2 2.2 0 0 0 0-3l-1.9-1.9a2.2 2.2 0 0 0-3.1 0L44.7 57.1 32.8 45a2.2 2.2 0 0 0-3.1 0l-1.9 2a2.2 2.2 0 0 0 0 3z" />,
);
